import { BaseService } from './base.service';

export class RoomService extends BaseService {
    baseUrl = '/room';
}
